import {
  EmojiHappyIcon,
  PaperClipIcon,
  SearchIcon,
} from "@heroicons/react/outline";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { useEffect, useRef } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useParams } from "react-router-dom";
import { auth, database } from "../../../database/firebase";
import useMessages from "../../../hooks/DatabseCollection/useMessages";
import MessageCard from "../../MessageCard/MessageCard";
import NoMessage from "../../NoMessage/NoMessage";

const Board = () => {
  const { roomId } = useParams();
  const [user] = useAuthState(auth);
  const messageTestRef = useRef();
  const { messageData } = useMessages(roomId);
  const chatRef = useRef(null);

  const sendMessage = async (e) => {
    e.preventDefault();
    try {
      try {
        await addDoc(collection(database, "userRooms", roomId, "messages"), {
          userName: user?.displayName,
          userId: user?.uid,
          userEmail: user?.email,
          userImage: user?.photoURL,
          message: messageTestRef.current.value,
          timestamp: serverTimestamp(),
        });

        messageTestRef.current.value = "";
      } catch (error) {
        alert(error.message);
      }
    } catch (error) {
      alert(error.message);
    }
  };

  useEffect(() => {
    chatRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  }, [roomId, messageData]);

  return (
    <div className="flex flex-col justify-between h-full">
      <div className="flex justify-between items-center border-b border-gray-300 shadow py-3 px-3">
        <h1>Chat Board</h1>
        <SearchIcon className="h-5" />
      </div>
      <div className="flex-1 py-5 px-5 flex flex-col  overflow-y-scroll h-full scrollbar-thin scrollbar-thumb-black">
        {messageData.length > 0 ? (
          <>
            {messageData.map(
              ({
                id,
                data: { message, timestamp, userId, userImage, userName },
              }) => (
                <>
                  <MessageCard
                    key={id}
                    id={id}
                    message={message}
                    timestamp={timestamp}
                    userImage={userImage}
                    userName={userName}
                    userId={userId}
                  />
                  <div className="pb-10" ref={chatRef} />{" "}
                </>
              )
            )}
          </>
        ) : (
          <div className="grid place-items-center">
            <NoMessage />
          </div>
        )}
      </div>
      <div className="bg-gray-200 py-4 px-5">
        <div>
          <form onSubmit={sendMessage} className="flex items-center w-full">
            <input
              type="text"
              ref={messageTestRef}
              placeholder="Post somehting on the board..."
              className="w-full px-5 py-2 focus:outline-none border border-gray-300 rounded-full"
            />
            <div className="flex items-center space-x-3 px-2">
              <EmojiHappyIcon className="h-6" />
              <PaperClipIcon className="h-6" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Board;
